import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

export interface ShareNoteDialogData {
  title: string;
}

export interface ShareNoteDialogResult {
  email: string;
  message?: string;
}

@Component({
  selector: 'app-share-note-dialog',
  standalone: true,
  template: `
    <h2 mat-dialog-title>Share note</h2>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="share-form" mat-dialog-content>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Recipient email</mat-label>
        <input matInput formControlName="email" type="email" placeholder="name@example.com" />
        <mat-error *ngIf="form.get('email')?.hasError('required')">
          Email is required
        </mat-error>
        <mat-error *ngIf="form.get('email')?.hasError('email')">
          Enter a valid email address
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Message (optional)</mat-label>
        <textarea matInput formControlName="message" rows="3"></textarea>
      </mat-form-field>
    </form>

    <div mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" [disabled]="form.invalid" (click)="onSubmit()">
        Send
      </button>
    </div>
  `,
  styles: [`
    .share-form {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      margin-top: 0.5rem;
    }
    .full-width {
      width: 100%;
    }
  `],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule
  ]
})
export class ShareNoteDialogComponent {
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ShareNoteDialogComponent, ShareNoteDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: ShareNoteDialogData
  ) {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      message: ['']
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.form.invalid) return;
    this.dialogRef.close(this.form.value);
  }
}
